import apiRequestService from '@/commonProject/service/apiRequestService';

export default class medicalQuestionnarieRepository {
    /**
     * 問診票フォーム取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getMedicalQuestionnarieFormActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/ivwfrm', queryParam, idToken);
        return result;
    }

    /**
     * 問診票フォーム登録APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async putMedicalQuestionnarieFormActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/ivwfrm', requestBody, idToken);
        return result;
    }

    /**
     * 問診票添付ファイルアップロードAPIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async uploadMedicalQuestionnarieFormFileActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/ivwfrmfiluld', requestBody, idToken);
        return result;
    }
}
